/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Col, Container, Row, Card } from 'react-bootstrap';
import { ClientErrorSVG } from '../img/ClientErrorSVG';
import GenericButton from '../../Components/GenericButton/GenericButton';
import './error.scss';

const CustomClientError = ({
  ErrorHeading,
  ErrorMessage,
  CustomClasses = null,
  className,
  disableMailTo,
  isReDirect = false,
  buttonLabel = '',
  onClickHandler = null,
}) => {
  return (
    <div>
      <Container fluid className={CustomClasses}>
        <Card className="mt-3 mb-3 p-5 card border-light">
          <div className="mtop30 logout">
            <Row className="h-100">
              <Col
                role="alert"
                aria-live="polite"
                className="my-auto error-container"
              >
                {/*<img
                  src={require( '../img/client-error.svg' )}
                  id="tick-img"
                  alt="Check Mark"
                  aria-hidden= {true}
                /> */}
                <ClientErrorSVG
                  className="client-error-mark"
                  parentClassName="clienterrorsvg"
                  circleClass="error-circle"
                />

                <Row className={`w-60 mx-auto error-msg ${className}`}>
                  <Col>
                    <h1>{ErrorHeading}</h1>
                    <p>
                      {ErrorMessage}
                      {/*{ !disableMailTo &&
                        <a href="mailto:tpacustomerservice@keenan.com">
                          mailto:tpacustomerservice@keenan.com
                        </a> } */}
                    </p>
                  </Col>
                </Row>
                {isReDirect && (
                  <Row>
                    <Col>
                      <GenericButton
                        onClick={onClickHandler}
                        variant="primary"
                        className="login-button d-flex mx-auto text-center "
                      >
                        {buttonLabel}
                      </GenericButton>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default CustomClientError;
